import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCalendar, faClock, faMessage, faUser, faStethoscope, faCheckCircle, faInfo } from "@fortawesome/free-solid-svg-icons";
import { useMemo } from "react";
import "./componentsCss/ConfirmationPage.css";
import { formatCPF } from "../utils/formats";

const ConfirmationPage = ({
  patient,
  procedures,
  doctor,
  details, // { date, time, comments }
  onConfirm,
  onBack,
}) => {
  const getProcPrice = (proc) => {
    const byId =
      doctor?.prices?.[proc.procedure_id ?? proc.id] ??
      doctor?.prices?.[proc.id];

    if (typeof byId === "number" && !isNaN(byId)) return byId;

    return Number(proc.value ?? proc.cost_price ?? proc.price ?? 0);
  };

  const allInsurance = procedures.every((p) => p.payment?.type === "insurance");

  const totalPrice = useMemo(
    () =>
      procedures.reduce((sum, proc) => {
        if (proc.payment?.type === "insurance") return sum;
        return sum + getProcPrice(proc);
      }, 0),
    [procedures]
  );

  const formatCurrency = (v = 0) =>
    `R$ ${Number(v).toFixed(2).replace(".", ",")}`;

  const formatDate = (iso) =>
    new Date(iso + "T00:00:00").toLocaleDateString("pt-BR", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  /* ─────────── JSX ─────────── */
  return (
    <div className="page-container confirmation-page">
      {/* ---------- Cabeçalho ---------- */}
      <div className="page-header">
        <button className="back-button" onClick={onBack}>
          <FontAwesomeIcon icon={faArrowLeft} />
          <span>Voltar</span>
        </button>
        <h1>Confirmação de Agendamento</h1>
      </div>

      <div className="confirmation-content">
        {/* ---------- Resumo ---------- */}
        <section className="summary-section">
          {/* Card agrupado com as três primeiras informações */}
          <div className="summary-card-group">
            {/* Paciente */}
            <div className="summary-info-line">
            <FontAwesomeIcon icon={faUser} />
              <div>
                <h4>Paciente</h4>
                <p>{patient.name}</p>
                <p>CPF: {formatCPF(patient.cpf)}</p>
              </div>
            </div>

            {/* Profissional */}
            <div className="summary-info-line">
            <FontAwesomeIcon icon={faStethoscope} />
              <div>
                <h4>Profissional</h4>
                <p>{doctor.name}</p>
                {/* <p>{doctor.specialty}</p> */}
              </div>
            </div>

            {/* Data & Hora */}
            <div className="summary-info-line date-time-line">
            <FontAwesomeIcon icon={faCalendar} />
              <div>
                <h4>Data</h4>
                <p>{formatDate(details.date)}</p>
              </div>
              <FontAwesomeIcon icon={faClock} />
              <div>
                <h4>Hora</h4>
                <p>{details.time}</p>
              </div>
            </div>
          </div>

          {/* Observações - permanece como card separado */}
          {details.comments && (
            <div className="summary-card">
              <FontAwesomeIcon icon={faMessage} />
              <div>
                <h4>Observações</h4>
                <p>{details.comments}</p>
              </div>
            </div>
          )}
        </section>

        {/* ---------- Procedimentos ---------- */}
        <section className="procedures-section">
          <h3>
          <FontAwesomeIcon icon={faCheckCircle} style={{ marginRight: 6 }} />
            Procedimentos
          </h3>

          <ul className="procedures-list">
            {procedures.map((proc) => {
              const price = getProcPrice(proc);
              return (
                <li key={proc.id}>
                  <span>{proc.name}: </span>
                  <span className="procedure-price">
                    {proc.payment?.type === "insurance"
                      ? "Convênio"
                      : formatCurrency(price)}
                  </span>
                </li>
              );
            })}
          </ul>

          <div className="total-price-container">
            <span>Valor&nbsp;Total:</span>
            <span className="total-price-value">
              {allInsurance ? "Convênio" : formatCurrency(totalPrice)}
            </span>
          </div>
        </section>

        {/* ---------- Ações ---------- */}
        <div className="form-actions">
          <button type="button" className="cancel-button" onClick={onBack}>
          <FontAwesomeIcon icon={faArrowLeft} />
            Voltar e Editar
          </button>
          <button
            type="button"
            className="submit-button"
            onClick={() => onConfirm({ patient, procedures, doctor, details })}>
            <FontAwesomeIcon icon={faCalendar} className="me-2"/>
            Confirmar Agendamento
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
